import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from "axios";
import API_URL from '../config/apiConfig';
import logo from '../assets/logo.png'; // Assure-toi que le chemin est bon

const ResetPassword = () => {
    const { token } = useParams();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (password !== confirmPassword) {
            setError("Les mots de passe ne correspondent pas");
            return;
        }

        if (password.length < 6) {
            setError("Le mot de passe doit contenir au moins 6 caractères");
            return;
        }

        setLoading(true);

        try {
            await axios.post(`${API_URL}/auth/reset-password/${token}`, { password });
            setSuccess("Mot de passe modifié avec succès ! Redirection...");
            
            // Redirection après 2 secondes
            setTimeout(() => {
                navigate('/login');
            }, 2000);
        } catch (err) {
            console.error(err);
            setError(err.response?.data?.msg || 'Le lien a expiré ou est invalide.');
        } finally {
            setLoading(false);
        }
    };

    return (
        // STRUCTURE IDENTIQUE
        <div className="h-screen w-full flex items-center justify-center bg-[#f8f9fa] relative overflow-hidden font-sans">
            
            {/* DÉCORATION D'ARRIÈRE-PLAN */}
            <div className="absolute top-0 left-0 w-full h-[55%] bg-[#1c2143] skew-y-[-4deg] transform origin-top-left -translate-y-24 z-0 shadow-xl"></div>

            <div className="relative z-10 w-full max-w-md px-6">
                
                <div className="bg-white rounded-2xl shadow-2xl p-10 border-t-4 border-[#Ceaa5b] flex flex-col items-center animate-fade-in-up">
                    
                    {/* Logo */}
                    <div className="mb-6 w-full flex justify-center">
                        <img src={logo} alt="AI Expertys" className="h-20 w-auto object-contain" />
                    </div>

                    <h2 className="text-xl font-bold text-[#1c2143] text-center mb-2">
                        Réinitialisation
                    </h2>
                    <p className="text-gray-400 text-center mb-6 text-sm">
                        Définissez votre nouveau mot de passe
                    </p>

                    <form className="w-full space-y-5" onSubmit={handleSubmit}>
                        
                        {/* Nouveau mot de passe */}
                        <div className="group">
                            <label className="block text-xs font-semibold text-gray-500 mb-1 ml-1 uppercase tracking-wider">Nouveau mot de passe</label>
                            <input
                                className="block w-full px-4 py-3 border border-gray-200 rounded-lg bg-gray-50 text-gray-800 placeholder-gray-400 
                                focus:outline-none focus:bg-white focus:ring-2 focus:ring-[#Ceaa5b] focus:border-transparent transition-all duration-200"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                required
                            />
                        </div>

                        {/* Confirmation */}
                        <div className="group">
                            <label className="block text-xs font-semibold text-gray-500 mb-1 ml-1 uppercase tracking-wider">Confirmez le mot de passe</label>
                            <input
                                className="block w-full px-4 py-3 border border-gray-200 rounded-lg bg-gray-50 text-gray-800 placeholder-gray-400 
                                focus:outline-none focus:bg-white focus:ring-2 focus:ring-[#Ceaa5b] focus:border-transparent transition-all duration-200"
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="••••••••"
                                required
                            />
                        </div>

                        {/* Messages d'erreur / Succès */}
                        {error && (
                            <div className="p-3 bg-red-50 text-red-600 text-xs font-medium rounded-md border border-red-100 text-center">
                                {error}
                            </div>
                        )}

                        {success && (
                            <div className="p-3 bg-green-50 text-green-600 text-xs font-medium rounded-md border border-green-100 text-center flex items-center justify-center gap-2">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                                {success}
                            </div>
                        )}

                        <button
                            className={`w-full py-3.5 px-4 rounded-lg shadow-lg text-sm font-bold text-white uppercase tracking-wider mt-4
                                ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#1c2143] hover:bg-[#2a3055] hover:shadow-xl'} 
                                transition duration-300 transform active:scale-[0.98] flex justify-center items-center`}
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <svg className="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Modification...
                                </>
                            ) : 'Réinitialiser'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;